/**
 * Created by maitray on 24/3/16.
 */

'use strict';

angular.module('adelementAdminApp')
    .factory('AeAdvertisersIdName', function ($resource, DateUtils) {
        return $resource('api/aeadvertisersidname/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.timezone = DateUtils.convertDateTimeFromServer(data.timezone);
                    data.creationTimestamp = DateUtils.convertDateTimeFromServer(data.creationTimestamp);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

